import { render } from "./DiagnosisTable.vue?vue&type=template&id=70401c2d"
import script from "./DiagnosisTable.vue?vue&type=script&lang=js"
export * from "./DiagnosisTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__